import {configureStore} from "@reduxjs/toolkit";
import {reducer as usersReducer} from "./slices/usersSlice";
import {reducer as dataReducer} from "./slices/dataSlice";

export default configureStore({
  reducer: {
    users: usersReducer,
    data: dataReducer
  }
})
